import { createReduxStore } from "src/store/redux_store";

const InvitationStore = createReduxStore({
  name: "invitation",
  initialState: {
    data: {
      hasRedeemedInvitation: null,
      hasValidInvitation: null,
    },
    loading: false,
    error: null,
  },
  reducers: {
    setIsValid: (state, { payload }) => {
      state.data.hasValidInvitation = payload;
      state.loading = false;
    },
    setIsRedeemed: (state, { payload }) => {
      state.data.hasRedeemedInvitation = payload;
      state.loading = false;
    },
  },
});

export { InvitationStore };
